import React, { useContext } from 'react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import loadable from '@loadable/component';
import { AppContext } from 'adapter';

const AccountView = loadable(() => import('./views/Account'));
const MineView = loadable(() => import('./views/Mine'));
const NotFoundView = loadable(() => import('./views/NotFound'));
const SignInView = loadable(() => import('./views/SignIn'));
const SignUpView = loadable(() => import('./views/SignUp'));
const SystemView = loadable(() => import('./views/System'));
const MetricsView = loadable(() => import('./views/Metric'));
// custom

const ProjectListView = loadable(() => import('./views/Project/projectList'));
const ProjectEditFormView = loadable(
  () => import('./views/Project/common/ProjectEditForm')
);
const ProjectWorkSpaceView = loadable(
  () => import('./views/Project/projectWorkspace')
);

const ApkAssetsListView = loadable(() => import('./views/ApkAsset'));

const ZedEngineView = loadable(() => import('./views/ZedEngine'));
const DeviceWorkSpaceView = loadable(() => import('./views/Device/workspace'));
const DeviceDetailView = loadable(() => import('./views/Device/detail'));
const LiveWallViewerView = loadable(
  () => import('./views/Device/workspace/LiveWallViewer')
);
const ShareDiskView = loadable(() => import('./views/ShareDisk'));

const DevicePreview = loadable(() => import('./views/Project/DevicePreview'));
const DeviceLog = loadable(() => import('./views/DeviceLog'));

// react-router-dom v7：RouteWithLayout 改为包装 element 的工厂，
// privateRoute 改为守卫组件，登录态过期时重定向到 sign-in
const wrapWithLayout = (Layout, Component) => (
  <Layout>
    <Component />
  </Layout>
);

const PrivateRoute = ({ layout: Layout, component: Component }) => {
  const { user } = useContext(AppContext);
  if (user.overdue) {
    return <Navigate to='/sign-in' />;
  }
  return wrapWithLayout(Layout, Component);
};

const privateRoute = (Layout, Component) => (
  <PrivateRoute layout={Layout} component={Component} />
);

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path='/' element={<Navigate to='/mine' />} />
      <Route
        path='/accountList'
        element={privateRoute(MainLayout, AccountView)}
      />
      <Route path='/mine' element={privateRoute(MainLayout, MineView)} />
      <Route
        path='/systemSettings'
        element={privateRoute(MainLayout, SystemView)}
      />
      <Route
        path='/sign-in'
        element={wrapWithLayout(MinimalLayout, SignInView)}
      />
      <Route
        path='/sign-up'
        element={wrapWithLayout(MinimalLayout, SignUpView)}
      />
      <Route
        path='/not-found'
        element={wrapWithLayout(MinimalLayout, NotFoundView)}
      />
      <Route path='/metrics' element={privateRoute(MainLayout, MetricsView)} />
      {/* custom begin */}
      <Route
        path='/projectList'
        element={privateRoute(MainLayout, ProjectListView)}
      />
      <Route
        path='/projectEdit/:projectId?'
        element={privateRoute(MainLayout, ProjectEditFormView)}
      />
      <Route
        path='/projectWorkSpace/:projectId'
        element={privateRoute(MainLayout, ProjectWorkSpaceView)}
      />
      <Route
        path='/apkAssets'
        element={privateRoute(MainLayout, ApkAssetsListView)}
      />

      <Route
        path='/zedEngineList'
        element={privateRoute(MainLayout, ZedEngineView)}
      />

      <Route
        path='/device'
        element={privateRoute(MainLayout, DeviceWorkSpaceView)}
      />
      <Route
        path='/deviceDetail/:deviceUuid'
        element={privateRoute(MainLayout, DeviceDetailView)}
      />

      <Route
        path='/liveWallView/:wallId'
        element={privateRoute(MainLayout, LiveWallViewerView)}
      />
      <Route
        path='/shareDisk'
        element={privateRoute(MainLayout, ShareDiskView)}
      />
      <Route
        path='/devicePreview/:ids'
        element={privateRoute(MainLayout, DevicePreview)}
      />
      <Route path='/deviceLog' element={privateRoute(MainLayout, DeviceLog)} />
      <Route path='*' element={<Navigate to='/not-found' />} />
    </RouterRoutes>
  );
};

export default Routes;
